import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class BlockSliderMedias {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-medias__swiper', {
      modules: [Pagination],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      preventInteractionOnTransition: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1025: {
          slidesPerView: 2,
          spaceBetween: 24
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  }
}

export const blockSliderMedias = new BlockSliderMedias();
